import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';

type Reason = 'missing' | 'expired';

interface ShareLinkInvalidProps {
  reason: Reason;
}

const ShareLinkInvalid: React.FC<ShareLinkInvalidProps> = ({ reason }) => {
  return (
    <Box
      minH="100vh"
      bg="gray.50"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={{ base: 4, md: 8 }}
      fontFamily="Inter, sans-serif"
    >
      <VStack spacing={4} maxW="480px" textAlign="center">
        <Heading
          as="h1"
          fontSize={{ base: '2xl', md: '3xl' }}
          color="gray.900"
          fontWeight="600"
        >
          {reason === 'missing' ? 'Share link is invalid' : 'Share link has expired'}
        </Heading>
        <Text fontSize="md" color="gray.600">
          {reason === 'missing'
            ? 'This link is missing the access token needed to view the dashboard. Please request a new link from the sender.'
            : 'This link is no longer valid. It may have been revoked or expired. Please request a new link from the sender.'}
        </Text>
      </VStack>
    </Box>
  );
};

export default ShareLinkInvalid;
